<!--
 * @Author: houmy
 * @Date: 2023-10-10 14:26:18
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-10-27 17:08:27
 * @FilePath: \zx-home\src\views\About.vue
 * @Description: 
 * 
-->
<template>
    <div class="page">
        <Contact></Contact>
        <img class="newsBanner" src="../assets/img/关于我们/关于我们banner.png" alt="">
        <div class="pos home-box height800" ref="introElement">
            <div class="home-title">
                <span class="title-english">{{ 'Company Introduction'.toUpperCase() }}</span>
                <div class="title-divider">
                    <img src="@/assets/img/title-left.png" alt="Divider" />
                    <span class="title-chinese">公司介绍</span>
                    <img src="@/assets/img/title-right.png" alt="Divider" />
                </div>
                <div class="description">
                    技术推动，智慧未来
                </div>
            </div>
            <img class="descPic-bg" src="../assets/img/关于我们/1公司介绍.png" alt="">
            <div class="w12 ">
                <div class="firmInfo">
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;广东六力智行科技有限公司成立于2022年7月7日。</p>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们坚持以技术驱动产品, 目前公司整体研发人员占比超过80%，其中本科70%，硕士20%，博士10%, 车载行业8年以上经验的占80%。核心团队深耕目标场景多年，属于国内最早一批农机无人驾驶研究团队，深度理解车辆控制/农艺和工艺/用户诉求和痛点。</p>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;自公司创立以来, 我们以路径规划/控制技术/融合感知结合单机/多机全覆盖最优路径规划等行业领先技术, 整合农业和工程机械行业龙头资源和关键需求，基于共性技术平台底座衍生的产品，拓展产品应用范围，致力于为农业、工程机械以及环卫无人化进程提供智能化产品、服务和整体解决方案。</p>
                </div>
            </div>
        </div>

        <div class="pos home-box height800">
            <div class="home-title">
                <span class="title-english">{{ 'Development course'.toUpperCase() }}</span>
                <div class="title-divider">
                    <img src="@/assets/img/title-left.png" alt="Divider" />
                    <span class="title-chinese">发展历程</span>
                    <img src="@/assets/img/title-right.png" alt="Divider" />
                </div>
                <div class="description">
                    艰苦奋斗，不忘初心，展望未来，勇担时代责任
                </div>
            </div>
            <img class="descPic-bg" src="../assets/img/关于我们/2发展历程.png" alt="">
            <img class="timeLineImg" src="../assets/img/关于我们/2发展历程1.png" />
            <div class="w1210 developmentWrap">
                <swiper :options="swiperOptionsDev">
                    <swiper-slide v-for="(item, index) in developmentArr" :key="index">
                        <div class="timeSlider">
                            <h1>{{ item.year }}</h1>
                            <img v-if="item.year" src="../assets/img/关于我们/year.png" />
                            <img v-else-if="item.month !== '--'" class="monthImg" src="../assets/img/关于我们/month-light.png" />
                            <img v-else class="monthImg" src="../assets/img/关于我们/month.png" />
                            <div class="developmentMain" :class="{ 'active': item.month !== '--' }">
                                <h2>{{ item.month }}<b>月</b></h2>
                                <ul>
                                    <li v-for="item2 in item.list">
                                        <span></span>
                                        {{ item2 }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </swiper-slide>
                </swiper>
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
            </div>
        </div>
        <div class="pos home-box height800 whiteBg">
            <div class="home-title">
                <span class="title-english">{{ 'Business Philosophy'.toUpperCase() }}</span>
                <div class="title-divider">
                    <img src="@/assets/img/title-left.png" alt="Divider" />
                    <span class="title-chinese">经营理念</span>
                    <img src="@/assets/img/title-right.png" alt="Divider" />
                </div>
                <div class="description">
                    诚信力、创新力、担当力、战斗力、匠心力、学习力
                </div>
            </div>
            <ul class="businessMain w12">
                <li>
                    <img src="../assets/img/关于我们/3市场导向.png" alt="">
                    <div class="content">
                        <h1><b>01</b>市场导向</h1>
                        <p>不断分析市场变化、掌握客户需求、从而改进产品和服务，获得市场竞争优势。</p>
                    </div>
                </li>
                <li>
                    <div class="content">
                        <h1><b>02</b>客户至上</h1>
                        <p>将客户的需求和满意度放在首位，通过提供高品质的产品和服务，赢得客户的信任和忠诚。</p>
                    </div>
                    <img src="../assets/img/关于我们/3客户至上.png" alt="">

                </li>
                <li>
                    <img src="../assets/img/关于我们/3求是创新.png" alt="">
                    <div class="content">
                        <h1><b>03</b>求是创新</h1>
                        <p>实事求是，在实践中不断探索新的产品、技术和商业模式，加强技术研发和市场调研。</p>
                    </div>
                </li>
                <li>
                    <div class="content">
                        <h1><b>04</b>精益求精</h1>
                        <p>不断追求卓越，不断改进产品和服务的质量，以获得更高的客户满意度和产品竞争力。</p>
                    </div>
                    <img src="../assets/img/关于我们/3精益求精.png" alt="">

                </li>
            </ul>


        </div>

        <div class="pos home-box height800">
            <div class="home-title">
                <span class="title-english">{{ 'Team strength'.toUpperCase() }}</span>
                <div class="title-divider">
                    <img src="@/assets/img/title-left.png" alt="Divider" />
                    <span class="title-chinese">团队实力</span>
                    <img src="@/assets/img/title-right.png" alt="Divider" />
                </div>
                <div class="description">
                    无人化作业解决方案研发落地的核心能力
                </div>
            </div>
            <ul class="teamMain w12">
                <li>
                    <b>软硬件平台化设计</b>
                </li>
                <li>
                    <b>系统整体集成</b>
                </li>
                <li>
                    <b>场景定制开发</b>
                </li>
                <li>
                    <b>核心算法</b>
                </li>

            </ul>


        </div>
        <img class="hopeImg" src="../assets/img/关于我们/5我们的愿景.png" alt="">
        <div class="contactInsideUs contactUs home-box height800">
            <div class="home-title" style="margin-top: 120px;">
                <span class="title-english">{{ 'Contact us'.toUpperCase() }}</span>
                <div class="title-divider">
                    <img src="@/assets/img/title-left.png" alt="Divider" />
                    <span class="title-chinese">联系我们</span>
                    <img src="@/assets/img/title-right.png" alt="Divider" />
                </div>
                <div class="description">
                    期待与您一起携手并进
                </div>
            </div>
            <ul class="w12 contactMain flex-row">
                <li>
                    <img src="@/assets/img/shouye_lianxi1.png" alt="Divider" />
                    <h4>联系电话</h4>
                    <p>13974811172（微信同号）</p>
                </li>
                <li>
                    <img src="@/assets/img/shouye_lianxi2.png" alt="Divider" />
                    <h4>业务合作</h4>
                    <p>business@sforceauto.com</p>
                </li>
                <li>
                    <img src="@/assets/img/shouye_lianxi3.png" alt="Divider" />
                    <h4>人才招聘</h4>
                    <p>zhaopin@sforceauto.com</p>
                </li>
                <li>
                    <img src="@/assets/img/shouye_lianxi4.png" alt="Divider" />
                    <h4>公司地址</h4>
                    <p>广东省佛山市顺德区陈村镇莱茵科技园3栋702</p>
                </li>
            </ul>
        </div>
        <div class="logoBox home-box height800">
            <div class="home-title" style="margin-top: 120px;">
                <span class="title-english  whiteText">{{ 'partners'.toUpperCase() }}</span>
                <div class="title-divider">
                    <img src="@/assets/img/title-left.png" alt="Divider" />
                    <span class="title-chinese whiteText">合作伙伴</span>
                    <img src="@/assets/img/title-right.png" alt="Divider" />
                </div>
                <div class="description whiteText">
                    互惠互利，合作双赢
                </div>
            </div>
            <div class="w1026">
                <swiper :options="swiperOptions">
                    <swiper-slide v-for="(item, index) in logoArr" :key="index">
                        <ul class="logoWrap">
                            <li v-for="item2 in item">
                                <img :src="item2" alt="">
                            </li>
                        </ul>
                    </swiper-slide>
                </swiper>
            </div>
        </div>
    </div>
</template>
    
<script>
import Contact from '../components/Contact.vue'
import solutionJson from '@/assets/data/solution.json'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
export default {
    components: {
        Swiper,
        SwiperSlide,
        Contact
    },

    data() {
        return {
            swiperOptions: {
                activeIndex: 0,
                slidesPerView: 6,
                spaceBetween: 22,
                loop: true,
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false,
                },
            },
            swiperOptionsDev: {
                activeIndex: 0,
                initialSlide: 6,
                slidesPerView: 5,
                spaceBetween: 20,
                loop: false,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'custom'
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            },
            logoArr: [
                [
                    require('../assets/img/关于我们/LOGO1.png'),
                    require('../assets/img/关于我们/LOGO2.png'),
                    require('../assets/img/关于我们/LOGO3.png'),
                ],
                [
                    require('../assets/img/关于我们/LOGO4.png'),
                    require('../assets/img/关于我们/LOGO5.png'),
                    require('../assets/img/关于我们/LOGO6.png'),
                ],
                [
                    require('../assets/img/关于我们/LOGO7.png'),
                    require('../assets/img/关于我们/LOGO8.png'),
                    require('../assets/img/关于我们/LOGO21.png'),
                ],
                [
                    require('../assets/img/关于我们/LOGO13.png'),
                    require('../assets/img/关于我们/LOGO20.png'),
                    require('../assets/img/关于我们/LOGO10.png'),
                ], [
                    require('../assets/img/关于我们/LOGO19.png'),
                    require('../assets/img/关于我们/LOGO17.png'),
                    require('../assets/img/关于我们/LOGO18.png'),
                ],


            ],
            developmentArr: [
                {
                    'year': '2022',
                    'month': '07',
                    'list': ['广东六力智行科技有限公司成立']
                }, 
                {
                    'year': '2023',
                    'month': '04',
                    'list': ['SCW200非道路碰撞预警系统量产']
                }, 
                {
                    'month': '09',
                    'list': ['SAVM智能环视预警系统量产', 'SAD200自动驾驶作业系统量产']
                }, 
                {
                    'month': '10',
                    'list': ['智驾域控制器量产', '座舱域控制器量产']
                },
                {
                    'year': '2024',
                    'month': '09',
                    'list': ['国家级科技中小企业认定']
                },
                {
                    'month': '11',
                    'list': ['国家高新技术企业认定']
                },
                {
                    'month': '-',
                    'list': ['']
                },
                {
                    'month': '-',
                    'list': ['']
                },
            ]
        };
    },
    watch: {
        '$route'(val, from) {
            if (val.query.anchor) {
                if (val.query.anchor === '1') {
                    this.scrollToTargetElement()
                }
            }
        }
    },
    mounted() {
        const anchor = this.$route.query.anchor
        if (anchor === '1') {
            this.scrollToTargetElement()
        }
        this.$nextTick(() => {
            window.scrollTo(0, 0)
        })
    },
    methods: {
        scrollToTargetElement() {
            const targetElement = this.$refs.introElement
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth' })
            }
        },
        // 跳转详情
        toDetail(id) {
            this.$router.push({
                path: '/solutionDetail',
                query: {
                    id: id,
                }
            })
        },
        // 图片回显
        getImagePath(imageName) {
            return require(`@/assets${imageName}`);
        },

    }
};
</script>
    
<style scoped></style>
    


// WEBPACK FOOTER //
// src/views/About.vue